import { NgModule } from '@angular/core';

import { SharedModule } from '../shared/shared.module';
import { StaticRoutingModule } from './static-routing.module';

@NgModule({
  imports: [SharedModule, StaticRoutingModule],
  declarations: [],
})
export class StaticModule {
  // TODO: currently this module is empty. For some static pages.
}
